import Vue from "vue";
import App from "./App.vue";
import store from "./store/store.js";
import i18n from "./i18n";
import router from "./router";
import VueCookies from "vue-cookies";
import VueAnnouncer from '@vue-a11y/announcer'

import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

// google analytics
window.dataLayer = window.dataLayer || [];
function gtag() {
  // eslint-disable-next-line
  dataLayer.push(arguments);
}
gtag('js', new Date()); gtag('config', 'G-R647GJJR66');

// sentry
Sentry.init({
  release: "tickets-ontarionorthland-ca@1.2.11",
  dsn:
    "https://e790f8e3aa644a6280d3655cdf29621f@o1269297.ingest.sentry.io/6479437",
  integrations: [
    new BrowserTracing({
      tracingOrigins: ["api.betterez.com"],
    }),
    new Sentry.Integrations.Breadcrumbs({
      console: true,
      xhr: true,
      fetch: true,
      dom: true,
    }),
  ],
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category == "xhr") {
      // log non 200 responses
      if (hint.xhr.status != "200") {
        Sentry.setTag("xhr-response-status", "failed");
        Sentry.setTag("xhr-response-url", hint.xhr.responseURL);

        Sentry.addBreadcrumb({
          category: "xhr-response",
          message: hint.xhr.response,
          level: "error",
        });
      }

      // attach the seatmap reponse
      //if (hint.xhr.responseURL.search(/seatmaps/i) != -1 ) {
      //	Sentry.configureScope(scope => {
      //		scope.addAttachment({ filename: "seatmap.txt", data: hint.xhr.responseURL + "\n" + hint.xhr.response });
      //	});
      //}

      // 	message: hint.xhr.__sentry_xhr__.body.items,
    }

    return breadcrumb;
  },
  // Set tracesSampleRate to 1.0 to capture 100%
  tracesSampleRate: 0.1,
});

Vue.config.productionTip = false;
Vue.use(VueCookies, { expire: "7d" });
Vue.use(VueAnnouncer, {}, router);

Vue.use(VueAnnouncer, {}, router);

router.beforeEach((to, from, next) => {
  if (to.path.includes('/cart')) {
    if (store.state.cart.cartId && !store.getters.isCartValid) {
      alert(i18n.t('cart_expired'));
      store.commit('EMPTY_CART');
      return next('/');
    }
  }
  next();
});

new Vue({
  store,
  i18n,
  router,
  VueCookies,
  render: (h) => h(App),
}).$mount("#webdrive-vue-websales");
